import { Moment } from 'moment';
import { PageRequest } from '@/core/request/PageRequest';
import { StockItem } from '../../stock/StockItems/StockItems.types';
import { InvoiceType } from '../../invoice/invoices/invoices.enums';
import { SaleTag } from '../SaleTags/SaleTags.types';

export enum StockItemType {
  Part = 'domain.enums.item_type.part',
  Consumable = 'domain.enums.item_type.consumable',
}

export enum DirectSaleStatusEnum {
  OPEN = 'OPEN',
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  PRINTED = 'PRINTED',
}

export enum DirectSaleModelInvoice {
  nfe = 'NFE_MODELO_55',
  nfce = 'NFC_E_MODELO_65',
}

export interface SaleItems {
  id: number;
  discount?: number;
  discountCurrency?: number;
  excluded?: boolean;
  quantity: number;
  reservedQuantity?: number;
  saleId?: number;
  unitPrice: number;
  unitCost: number;
  manufacturer?: {
    id: number;
    name: string;
  };
  part: {
    id: number;
    manufacturerName: string;
    manufacturingCode: string;
    sku: string;
    name: string;
  };
}

export interface SaleItemsCreate {
  discount?: number;
  excluded?: boolean;
  quantity: number;
  reservedQuantity?: number;
  saleId?: number;
  unitPrice: number;
  unitCost?: number;
  partId?: number;
}

export interface SaleItemsUpdate {
  discount?: number;
  excluded?: boolean;
  partId?: number;
  quantity: number;
  reservedQuantity?: number;
  saleId?: number;
  unitPrice: number;
}

export interface DirectSaleFormValues {
  companyId: number;
  customerId: number;
  customerName: string;
  employeeId: number;
  note?: string;
  saleDate: Moment;
  authorizationDate?: Moment;
  cancellationDate?: Moment;
  reasonCancellation?: string;
  items: DirectSaleStockItem[];
  situation?: string;
  saleCode?: string;
  saleTag: SaleTag;
}

export type DirectSaleStockItem = StockItem & {
  id: number;
  itemIndex: number;
  unitaryValue: number;
  discountCost: number;
  discount: number;
  unitCost?: number;
  discountCurrency: number;
  manufacturerId: number;
  configDiscount?: number;
};

export interface DirectSale {
  authorizationDate: string;
  cancellationDate: string;
  companyId: number;
  createDate: string;
  saleDate: string;
  customerId: number;
  employeeId: number;
  id: number;
  invoiceId: number;
  items: SaleItems[];
  note: string;
  open: boolean;
  authorized: boolean;
  reasonCancellation: string;
  status: DirectSaleStatusEnum;
  saleCode: string;
  saleTag: SaleTag;
  generatedFinancial: boolean;
}

export interface ListDirectSaleQuery extends PageRequest {
  status?: string;
  createDate?: string;
  companyId?: number;
  customerName?: string;
  code?: string;
  search?: string;
  manufacturerId?: number;
  partId?: number;
  tagsIds?: number;
}

export interface CreateDirectSaleRequest {
  companyId: number;
  customerId: number;
  employeeId: number;
  items: SaleItemsCreate[];
  note: string;
  saleDate: string;
}

export interface UpdateDirectSaleRequest {
  id: number;
  companyId: number;
  customerId: number;
  employeeId: number;
  items: SaleItemsUpdate[];
  note: string;
  saleDate: string;
  tagId?: number;
  authorizationDate?: string;
}

export interface DirectSaleAuthorizationOrCancelation {
  reasonCancellation?: string;
  status: DirectSaleStatusEnum;
}

export interface DirectSaleModalsFormValues {
  reasonCancellation?: string;
  companyId: number;
  invoiceType: InvoiceType;
}

export interface DirectSaleStatisticsRequest {
  companyIds?: number[];
  startDate?: string;
  endDate?: string;
}

export interface DirectSaleStatisticsResponse {
  authorizedPercentage: number;
  openPercentage: number;
  canceledPercentage: number;
  authorizedSaleRevenue: number;
  openSaleRevenue: number;
  canceledSaleRevenue: number;
  authorizedToOpenRatio: number;
  openToAuthorizedRatio: number;
  totalSaleRevenue: number;
}

export interface DirectSaleUpdateTagRequest {
  saleId?: number;
  tagId?: number;
}

export interface DirectSaleApplyTotalDiscountRequest {
  discountValue: number;
  saleId: number;
}
